import {
    ApolloClient,
    createHttpLink,
    InMemoryCache,
    makeVar,
    useReactiveVar,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { storage } from '../utils/index'

const httpLink = createHttpLink({
    uri: `https://fruitapps.myshopify.com/api/graphql`,
})

const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            'Accept-Language': localStorage.language || 'en',

            'X-Shopify-Storefront-Access-Token': 'e924123ae32997669b5dde56c5f6100b',
        },
    }
})
export const cartItemsVar = makeVar(storage.getItem('cartItems') || [])
export const checkoutVar = makeVar(storage.getItem('checkout') || '')

export const setCheckout = (checkout) => {
    storage.setItem('checkout', checkout)
    checkoutVar(checkout)
}

export const cache = new InMemoryCache({
    //    typePolicies: {
    //        Query: {
    //            fields: {
    //                cartItems:cartItemsVar()
    //            }
    //        }
    //    }
})

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
})

export default client

export const useCartTotal = () => {
    const { lineItems } = useReactiveVar(checkoutVar)

    const total = lineItems?.edges.reduce((left, { node }) => left + node.quantity, 0)
    return total
}
